var ChartGradientColor;
(function (ChartGradientColor) {
    ChartGradientColor["GreenMini"] = "chart-gradient-mini-green";
    ChartGradientColor["RedMini"] = "chart-gradient-mini-red";
    ChartGradientColor["GreenFull"] = "chart-gradient-full-green";
    ChartGradientColor["RedFull"] = "chart-gradient-full-red";
    ChartGradientColor["GreenCard"] = "chart-gradient-card-green";
    ChartGradientColor["RedCard"] = "chart-gradient-card-red";
})(ChartGradientColor || (ChartGradientColor = {}));

export { ChartGradientColor };
